<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Operator Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  {{ rentalLabel }} &hyphen; Chauffeur Rate
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    {{ rentalLabel }} &hyphen; Chauffeur Rate
                    <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>Set all rental rate.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Class</th>
                  <th class="text-center">Combinations</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="detail-row"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>{{ item.masterClassName }}</td>
                  <td
                    class="text-center"
                    :class="{ 'sts-danger': item.rateCount === 0 }"
                  >
                    {{ item.rateCount === 0 ? "N/A" : item.rateCount }}
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="
                          isAllowToCreate || isAllowToUpdate || isAllowToDelete
                        "
                        class="btn btn-default"
                        type="button"
                        @click="manageRate(item)"
                      >
                        <span>Manage</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div
              class="dataTables_info --blue25"
              style="padding-top: 15px; padding-bottom: 15px"
            >
              <strong>{{ items.length }} Records</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div
      class="modal fade"
      role="dialog"
      ref="vuemodal"
      v-if="selectedMasterClass"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-buy" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  {{ rentalLabel }} &hyphen; Chauffeur Rate ({{
                    selectedMasterClass.masterClassName
                  }})
                </h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="row">
                      <!-- Start: Form -->
                      <div
                        class="col-sm-3 divider-right pr-25"
                        v-if="userType !== 'ProviderUser'"
                      >
                        <div class="form-group">
                          <label class="required">Rate Type</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.type.$error,
                            }"
                            placeholder=""
                            label="label"
                            v-model="model.type"
                            :options="types"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.text"
                          ></v-select>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.type.required"
                            >Type is required</small
                          >
                        </div>
                        <div class="form-group">
                          <label class="required">Group Zone(s)</label>
                          <multiselect
                            v-model="model.zoneGroupIds"
                            :class="{
                              'field-error':
                                isSubmitted && !$v.model.zoneGroupIds.required,
                            }"
                            :options="groups"
                            :multiple="true"
                            :close-on-select="false"
                            placeholder="Select group zone(s)"
                            label="label"
                            track-by="id"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted && !$v.model.zoneGroupIds.required
                            "
                          >
                            Group zone(s) is required
                          </small>
                        </div>
                        <div class="form-group">
                          <label class="required">Minimum Hire Duration</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.model.minimumHireDuration.$error,
                            }"
                            type="number"
                            v-model="model.minimumHireDuration"
                            placeholder="Number"
                          />
                          <div
                            v-if="
                              isSubmitted && $v.model.minimumHireDuration.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.minimumHireDuration.required"
                              >Minimum Hire Duration is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.minimumHireDuration.minValue"
                              >Minimum Hire Duration is
                              {{
                                $v.model.minimumHireDuration.$params.minValue
                                  .min
                              }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">Pricing Unit (hours)</label>
                          <!-- <label class="required">Enter Duration</label> -->
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.duration.$error,
                            }"
                            type="number"
                            v-model="model.duration"
                            placeholder="Number"
                          />
                          <div v-if="isSubmitted && $v.model.duration.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.duration.required"
                              >Duration is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.duration.minValue"
                              >Min duration is
                              {{
                                $v.model.duration.$params.minValue.min
                              }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required"> Currency </label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.currency.$error,
                            }"
                            placeholder="Select currency"
                            label="text"
                            v-model="model.currency"
                            :options="currencies"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.value"
                          />
                          <div v-if="isSubmitted && $v.model.currency.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.currency.required"
                              >Currency is required</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required"> Rate </label>
                          <currency-input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.rate.$error,
                            }"
                            autocomplete="off"
                            placeholder="Enter rate"
                            v-model="model.rate"
                            :allow-negative="false"
                            :currency="null"
                          />
                          <div v-if="isSubmitted && $v.model.rate.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.required"
                              >Rate is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.rate.minValue"
                              >Min rate is
                              {{ $v.model.rate.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div
                          class="modal-footer"
                          v-if="isAllowToCreate || isAllowToUpdate"
                        >
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="reset()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                      <!-- End: Form -->
                      <!-- Start: Table -->
                      <div
                        :class="
                          userType !== 'ProviderUser'
                            ? 'col-sm-9 divider-left pl-20'
                            : 'col-sm-12'
                        "
                      >
                        <div class="table-modal-detail">
                          <div class="table-responsive table-accordion">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th class="number">No</th>
                                  <th>Type</th>
                                  <th>Group Zone(s)</th>
                                  <th class="text-center">
                                    Minimum Hire Duration
                                  </th>
                                  <th class="text-center">
                                    Pricing Unit (hours)
                                  </th>
                                  <!-- <th class="text-center">Duration</th> -->
                                  <th class="text-right">Rate</th>
                                  <th
                                    class="text-center"
                                    v-if="userType !== 'ProviderUser'"
                                  >
                                    Status
                                  </th>
                                  <th class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in rates"
                                  :key="item.id"
                                >
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td>
                                    {{ humanize(item.type) }}
                                  </td>
                                  <td>
                                    <template
                                      v-if="
                                        item.zoneGroups &&
                                        item.zoneGroups.length > 0
                                      "
                                    >
                                      <p
                                        class="mb-0"
                                        v-for="(
                                          zone, idxZone
                                        ) in item.zoneGroups"
                                        :key="idxZone"
                                      >
                                        {{ zone.name }}
                                      </p>
                                    </template>
                                    <template v-else> - </template>
                                  </td>
                                  <td class="text-center">
                                    {{
                                      item.minimumHireDuration
                                        ? item.minimumHireDuration
                                        : "-"
                                    }}
                                  </td>
                                  <td class="text-center">
                                    {{ item.duration }}
                                  </td>
                                  <td class="text-right">
                                    {{ item.currency }}
                                    {{
                                      item.rate.toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                      })
                                    }}
                                  </td>
                                  <td
                                    class="text-center"
                                    v-if="userType !== 'ProviderUser'"
                                  >
                                    <label class="cursor-pointer">
                                      <input
                                        type="checkbox"
                                        class="control-checkbox"
                                        v-model="item.isActive"
                                        :disabled="!isAllowToUpdate"
                                        @change="changeStatus(item)"
                                      />
                                      <span
                                        class="pl-5 font-weight-normal v-align-middle"
                                      >
                                        {{
                                          item.isActive ? "Active" : "Inactive"
                                        }}
                                      </span>
                                    </label>
                                  </td>
                                  <td class="text-center">
                                    <div
                                      class="button-action-wrapper button-action-wrapper-new"
                                      v-if="userType !== 'ProviderUser'"
                                    >
                                      <button
                                        v-if="isAllowToUpdate"
                                        class="btn btn-edit"
                                        type="button"
                                        @click="bindModel(item)"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          xmlns:xlink="http://www.w3.org/1999/xlink"
                                          viewBox="0 0 24 24"
                                        >
                                          <g
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          >
                                            <path
                                              d="M9 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3"
                                            ></path>
                                            <path
                                              d="M9 15h3l8.5-8.5a1.5 1.5 0 0 0-3-3L9 12v3"
                                            ></path>
                                            <path d="M16 5l3 3"></path>
                                          </g>
                                        </svg>
                                      </button>
                                      <button
                                        v-if="isAllowToDelete"
                                        class="btn btn-delete"
                                        type="button"
                                        @click="confirmDelete(item)"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          xmlns:xlink="http://www.w3.org/1999/xlink"
                                          viewBox="0 0 512 512"
                                        >
                                          <path
                                            d="M400 145.49L366.51 112L256 222.51L145.49 112L112 145.49L222.51 256L112 366.51L145.49 400L256 289.49L366.51 400L400 366.51L289.49 256L400 145.49z"
                                            fill="currentColor"
                                          ></path>
                                        </svg>
                                      </button>
                                    </div>
                                    <label v-else class="cursor-pointer">
                                      <input
                                        type="checkbox"
                                        class="control-checkbox"
                                        v-model="item.subscribed"
                                        @change="toggleSubscription(item)"
                                      />
                                      <span
                                        class="pl-5 font-weight-normal v-align-middle"
                                        >{{
                                          item.subscribed
                                            ? "Subscribed"
                                            : "Subscribe"
                                        }}
                                      </span>
                                    </label>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- End: Table -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />
    <!-- End: Modal -->

    <confirmModal
      :id="'confirmToggleSubscribeModal'"
      :header="'Unsubscribe'"
      :content="`Are you sure you want to unsubscribe from this tariff?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @onCancel="cancelSubscription"
      @submit="submitToggleSubscribe"
    />

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import confirmModal from "@/components/shared/ConfirmModal";
import deleteModal from "@/components/shared/DeleteModal";
import buyingTariffRentalRateService from "@/services/master/buyingTariff/buyingTariffRentalRateService.js";
import zoneService from "@/services/master/zone/zoneService.js";
import exchangeRateService from "@/services/master/exchangeRate/exchangeRateService.js";
import { tariffSubscribeService } from "@/services/master/tariffSubscribeService";

export default {
  components: {
    deleteModal,
    confirmModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isSubmitted: false,
      formatter: null,
      types: [],
      rentalLabel: null,
      allPermissions: [],
      selectedMasterClass: null,
      isUpdate: false,
      isItemHasBeenModified: false,
      itemToBeDeleted: null,
      items: [],
      rates: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
      currencies: [],
      groups: [],
      userType: "Unspecified",
      subscribeModel: {},
    };
  },
  validations() {
    return {
      model: {
        type: { required },
        minimumHireDuration: { required, minValue: minValue(0) },
        duration: { required, minValue: minValue(0) },
        zoneGroupIds: { required },
        currency: { required },
        rate: { required, minValue: minValue(0) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();

    await this.getAllGroups();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");

    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    this.userType = profile.userType;

    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getCommon();
      await this.getCurrency();
    }
  },
  updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("buying-rental-chauffeur-link");
  },
  methods: {
    startLoader() {
      this.isLoading = true;
    },
    stopLoader() {
      this.isLoading = false;
    },
    async getAllGroups() {
      const groups = await zoneService.getAllGroups();

      if (groups) {
        this.groups = groups.map((val) => ({ label: val.name, id: val.id }));
      }
    },
    async getCurrency() {
      const response = await exchangeRateService.getCurrencySelection();
      if (response && Object.keys(response).length > 0) {
        this.currencies = Object.entries(response).map(([key, value]) => ({
          value: key,
          text: value,
        }));
      }
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetModel() {
      this.model = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.vuemodal).modal({ backdrop: "static", keyboard: false });
    },
    async closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.vuemodal).modal("hide");
      if (this.isItemHasBeenModified) {
        await this.getAll();
      }
    },
    bindModel(item) {
      item.zoneGroupIds = item.zoneGroups.map((val) => ({
        id: val.id,
        label: val.name,
      }));
      this.isUpdate = true;
      this.resetValidations();
      this.model = Object.assign({}, item);
    },
    reset() {
      this.isUpdate = false;
      this.resetValidations();
      this.model = {};
    },
    async getAll() {
      try {
        this.isLoading = true;
        const response = await buyingTariffRentalRateService.getAll("");
        this.items = response.data;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCommon() {
      const common = await buyingTariffRentalRateService.getCommon(false);
      this.types = common.types;

      for (let i = 0; i < this.types.length; i++) {
        const item = this.types[i];
        item.label = this.humanize(item.text);
      }
    },
    async getRates(masterClassId) {
      this.rates = await buyingTariffRentalRateService.getRates(
        masterClassId,
        false
      );
    },
    async manageRate(item) {
      try {
        this.isLoading = true;
        this.isItemHasBeenModified = false;
        this.selectedMasterClass = item;
        await this.getRates(item.masterClassId);
        this.openModal({});
        this.isUpdate = false;
      } finally {
        this.isLoading = false;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      const groupZoneTemp = this.model.zoneGroupIds;
      try {
        this.isLoading = true;
        this.model.zoneGroupIds = this.model.zoneGroupIds.map((val) => val.id);
        this.model.rate = parseFloat(this.model.rate);
        this.model.duration = parseInt(this.model.duration);
        this.model.minimumHireDuration = parseInt(
          this.model.minimumHireDuration
        );
        if (this.isUpdate) {
          await buyingTariffRentalRateService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          this.model.isSelfDrive = false;
          this.model.masterClassId = this.selectedMasterClass.masterClassId;
          await buyingTariffRentalRateService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.reset();
        await this.getRates(this.selectedMasterClass.masterClassId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        this.model.zoneGroupIds = groupZoneTemp;
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        item.zoneGroupIds = item.zoneGroups.map((val) => val.id);
        delete item.zoneGroups;
        await buyingTariffRentalRateService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getRates(this.selectedMasterClass.masterClassId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async toggleSubscription(rate) {
      this.subscribeModel = Object.assign({}, rate);
      if (this.subscribeModel.subscribed) {
        await this.submitToggleSubscribe();
      } else {
        $("#confirmToggleSubscribeModal").modal();
      }
    },
    async submitToggleSubscribe() {
      const payload = {
        serviceType: 2,
        tariffId: this.subscribeModel.id,
        subscribed: this.subscribeModel.subscribed,
      };

      const response = await tariffSubscribeService.toggleSubscribe(
        payload,
        this.startLoader,
        this.stopLoader
      );

      if (response.isSuccess) {
        const rateItem = this.rates.find((e) => e.id === payload.tariffId);
        rateItem.subscribed = payload.subscribed;
        this.subscribeModel = {};
        if (payload.subscribed) {
          this.$notification.success("Successfully subscribed.", {
            title: "Success",
          });
        } else {
          this.$notification.success("Successfully unsubscribe.", {
            title: "Success",
          });
        }
      }
    },
    cancelSubscription() {
      const rateItem = this.rates.find((e) => e.id === this.subscribeModel.id);
      rateItem.subscribed = !rateItem.subscribed;
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await buyingTariffRentalRateService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getRates(this.selectedMasterClass.masterClassId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          $("body").addClass("modal-open");
        }, 500);
      }
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/RentalChauffeurRate.vue